module.exports = __webpack_public_path__ + "static/media/MemeMarket 600.ae6cef10.png";